import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from './localStorage';

export const REDIRECTED_TO_FEATURE_PAGE_FLAG = 'feature_suggested';

export const getIsExpired = (expirationTime: string) => {
  return new Date(expirationTime) < new Date();
};

export const setRedirectedToFeaturePageFlag = () => {
  setLocalStorageItem(REDIRECTED_TO_FEATURE_PAGE_FLAG, '1');
};

export const isRedirectedToFeaturePage = () => {
  return Boolean(getLocalStorageItem(REDIRECTED_TO_FEATURE_PAGE_FLAG));
};

export const removeIsRedirectedToFeaturePageFlag = () => {
  removeLocalStorageItem(REDIRECTED_TO_FEATURE_PAGE_FLAG);
};
